/* eslint-disable no-use-before-define */
import React from 'react'
import { icons } from './icons'

export const  iconLabel = (icon, label) => {
    const isSvgIcon = (Object.values(icons).includes(icon))
    return <React.Fragment>
        <div style={{
            display:  isSvgIcon ? 'inline-flex' : 'inline',
            alignItems:'center',
            verticalAlign:'middle',
        }}>
        {isSvgIcon
        ? <span style={{
            display:'inline-flex',
            alignItems:'center',
            verticalAlign:'middle',
            marginRight:'5px',
        }}>{icon}</span>
        : icon}
        {label}
        </div>
    </React.Fragment>
}


// WEBPACK FOOTER //
// ./src/twd/icon-label.js